export const version = '0.766.1'
export const chameleonWebVersion = '9.4.0'
export const chameleonCoreVersion = '7.7.0'
